<template>
  <div id="groupHeaderWhite" :class="{ show: isHeaderShow }">
    <div class="group-auto-size group-header-white" :style="{'max-width': maxWidth}">
      <img
        class="group-header-logo"
        src="https://dcse8twossp9.cloudfront.net/static/img/v2/icon/logo-black.svg"
        @click="moveToHome"
      />
      <div class="group-header-right pc">
        <a class="group-header-home group-header-text" href="/"><span>개인 고객</span></a>
        <a
          class="group-header-home group-header-text"
          @click="moveToB2b('groupSectionPrograms')"
        ><span>기업 고객</span></a>
        <div v-if='!isHideOfficeButton' class="group-header-line"></div>
        <p
          v-if='!isHideOfficeButton'
          class="group-header-button button--gra" @click="moveToB2b('introduction')">
          우리 회사 맞춤 제안서 받기
        </p>
      </div>
      <div class="group-header-right mo">
        <p
          v-if='!isHideOfficeButton'
          class="group-header-button button--gra" @click="moveToB2b('introduction')">
          맞춤 제안서 받기
        </p>
        <i class="group-header-menu" @click="toggleSideMenu()"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonHeaderV2',
  props: {
    isHeaderShow: { type: Boolean, default: false },
    isHideOfficeButton: { type: Boolean, default: false },
    maxWidth: { type: String, default: '860px' },
  },
  methods: {
    moveToHome() {
      window.location.href='/'
    },
    moveToB2b(hash) {
      window.location.href=`/f/office/#${hash}`
    },
    toggleSideMenu() {
      this.$emit('toggle-side')
    }
  },
}
</script>
<style scoped lang="scss">
$medium: 500;
@mixin flexBox($fd: row, $jc: flex-start, $ai: flex-start) {
  display: flex;
  flex-direction: $fd;
  justify-content: $jc;
  align-items: $ai;
}

@mixin defaultIcon($url, $size: cover) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: $size;
  background-position: center;
}

@mixin hiddenBreakLine($clamp: 1) {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $clamp;
  -webkit-box-orient: vertical;
}

@mixin positionCenter() {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


#groupHeaderWhite {
  letter-spacing: -1px !important;
  width: 100vw;
  height: 80px;
  background-color: #ffffff;
  margin: 0 auto;
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s ease;
  will-change: scroll-position;
  &.show {
    visibility: visible;
    opacity: 1;
  }
}
.group-header-white {
  height: 100%;
  @include flexBox(row, space-between, center);
  margin: 0 auto;
}
.group-header-logo {
  width: 132px;
  height: 24px;
  cursor: pointer;
}
.group-header-right {
  @include flexBox(row, flex-end, center);
  &.pc {
    display: flex;
  }
  &.mo {
    display: none;
  }
}
.group-header-home {
  font-weight: $medium;
  cursor: pointer;
  & + .group-header-home {
    margin-left: 7px;
  }
}
.group-header-text {
  display: inline-block;
  height: 80px;
  line-height: 80px;
  span {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    padding: 5px 8.5px;
    line-height: 1.4;
  }
  &:hover {
    span {
      border-radius: 16px;
      background-color: #000000;
      color: #ffffff;
    }
  }
  &.active {
    span {
      border-radius: 16px;
      background-color: #000000;
      color: #ffffff;
    }
  }
}
.group-header-line {
  width: 2px;
  height: 20px;
  background-color: #e1e1e1;
  margin: 0 31px;
}
.group-header-button {
  min-width: 92px;
  height: 48px;
  border-radius: 9px;
  cursor: pointer;
  font-weight: $medium;
  font-size: 16px;
  margin: 0;
  @include flexBox(row, center, center);
  padding: 0 14px;
  &.button--white {
    background-color: #ffffff;
    border: 1px solid #e1e1e1;
    margin-right: 12px;
  }
  &.button--gra {
    background-image: linear-gradient(107deg, #6400c8, #ff7d00);
    color: #ffffff;
  }
}
.group-header-menu {
  display: block;
  width: 24px;
  height: 24px;
  @include defaultIcon(
      'https://dcse8twossp9.cloudfront.net/static/img/v2/icon/menu-black.svg'
  );
  cursor: pointer;
  margin-left: 13px;
}
@media all and (max-width: 1023px) {
  #groupHeaderWhite {
    height: 54px;
  }
  .group-header-right {
    &.pc {
      display: none;
    }
    &.mo {
      display: flex;
    }
  }
  .group-header-button {
    min-width: 104px;
    height: 32px;
    font-size: 14px;
    padding: 0 7px;
  }
  .group-auto-size {
    padding: 0 24px;
  }
}
</style>
